import { render, staticRenderFns } from "./examinationArrangement.vue?vue&type=template&id=70cba695"
import script from "./examinationArrangement.vue?vue&type=script&lang=js"
export * from "./examinationArrangement.vue?vue&type=script&lang=js"
import style0 from "./examinationArrangement.vue?vue&type=style&index=0&id=70cba695&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports